import { update } from "react-spring";
import { apiSlice } from "../../app/api/apiSlice";

export const zoneApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    createZone: builder.mutation({
      query: (credentials) => ({
        url: `/zone/`,
        method: "POST",
        body: { ...credentials },
      }),
    }),
    updateZone: builder.mutation({
      query: ({ id, ...credentials }) => ({
        url: `/zone/${id}`,
        method: "PATCH",
        body: { ...credentials },
      }),
    }),
    fetchZones: builder.mutation({
      query: (credentials) => ({
        url: `/zone/`,
        method: "GET",
      }),
    }),
    fetchZoneProviders: builder.mutation({
      query: ({ id }) => ({
        url: `/zone/${id}/providers`,
        method: "GET",
      }),
    }),
    fetchZonePatients: builder.mutation({
      query: ({ id }) => ({
        url: `/zone/${id}/patients`,
        method: "GET",
      }),
    }),
    fetchZoneCommunities: builder.mutation({
      query: ({ id }) => ({
        url: `/zone/${id}/communities`,
        method: "GET",
      }),
    }),
    fetchPlannerZones: builder.mutation({
      query: (credentials) => ({
        url: `/zone/planner`,
        method: "POST",
        body: { ...credentials },
      }),
    }),
    upsertZoneLocations: builder.mutation({
      query: (credentials) => ({
        url: `/zone/upsert-zone-locations`,
        method: "POST",
        body: { ...credentials },
      }),
    }),
  }),
});

export const {
  useCreateZoneMutation,
  useUpdateZoneMutation,
  useFetchZonesMutation,
  useFetchZoneProvidersMutation,
  useFetchZonePatientsMutation,
  useFetchZoneCommunitiesMutation,
  useFetchPlannerZonesMutation,
  useUpsertZoneLocationsMutation,
} = zoneApiSlice;
